import {useState} from "react";
import {TextResponse} from "../../App";
import styles from "./Authorization.module.scss"
export type AuthorizeResult = {
	message: string;
	userData: AuthorizeResultUserData;
}
export type AuthorizeResultUserDataRole = {
	id: number;
	name: string;
	Rights?: any;
	Users?: any;
}
export type AuthorizeResultUserData = {
	id: number;
	name: string;
	surname: string;
	password: string;
	confirmationCode: string;
	email: string;
	roleId: number;
	Role: AuthorizeResultUserDataRole;
}
type AuthorizationProps = {
    setId:(id:number)=>void
    setName:(name:string)=>void
    setEmail:(email:string)=>void
    setSurname:(surname:string)=>void
    setRoleId:(roleId:number)=>void
    setToken:(token:string)=>void
    setAuthState:(state:boolean|null)=>void
}
export default function Authorization(props:AuthorizationProps){
    const [email, setEmail] = useState<string>("")
    const [password, setPassword] = useState<string>("")
    const [errorMessage, setErrorMessage] = useState<string>("")
    const [resultMessage, setResultMessage] = useState<string>("")
    const auth = ()=>{
        setErrorMessage("")
        setResultMessage("")
        props.setAuthState(null)
        fetch(process.env.REACT_APP_BASE_URL+"/Authorize",{
            method:"POST",
            body:JSON.stringify({
                email:email,
                password:password
            })
        }).then(async (response)=>{
            return {
                status:response.status,
                data:await response.json()
            }
        }).then((result)=>{
            if(result.status===200){
                props.setAuthState(true)
                props.setId((result.data as AuthorizeResult).userData.id)
                props.setRoleId((result.data as AuthorizeResult).userData.roleId)
                props.setEmail((result.data as AuthorizeResult).userData.email)
                props.setName((result.data as AuthorizeResult).userData.name)
                props.setSurname((result.data as AuthorizeResult).userData.surname)
                props.setToken((result.data as AuthorizeResult).message)
                localStorage.setItem("token",(result.data as AuthorizeResult).message)
            } else {
                setErrorMessage((result.data as TextResponse).message)
                props.setAuthState(false)
            }
        })
    }
    const resetPassword = ()=>{
        setErrorMessage("")
        setResultMessage("")
        props.setAuthState(null)
        fetch(process.env.REACT_APP_BASE_URL+"/ResetPassword",{
            method:"POST",
            body:JSON.stringify({
                email:email
            })
        }).then(async (response)=>{
            return {
                status:response.status,
                data:await response.json()
            }
        }).then((result)=>{
            if(result.status===200){
                setResultMessage((result.data as TextResponse).message)
            } else {
                setErrorMessage((result.data as TextResponse).message)
            }
            props.setAuthState(false)
        })
    }
    return(
        <div className={styles.Authorization}>
            <div style={{color:"#e01010"}}>{errorMessage}</div>
            <div style={{color:"#1b1f96"}}>{resultMessage}</div>
            <input className={styles.AuthorizationInput} value={email} onChange={(e)=>setEmail(e.target.value)} type={"text"}/>
            <input className={styles.AuthorizationInput} value={password} onChange={(e)=>setPassword(e.target.value)} type={"password"}/>
            <button className={styles.AuthorizationButton} onClick={auth}>Authorize</button>
            <button className={styles.AuthorizationButton} onClick={resetPassword}>Reset password</button>
        </div>
    )
}